{
  "welcome": {
    "title": "স্বাগতম, {{name}}",
    "title_noName": "Rhemn-এ স্বাগতম",
    "body": "যা কিছু আলো ছড়ায়, তা আপনাকে দেখাবে সেটি কী করে। যেকোনো ক্রমে, যখন খুশি ঘুরে দেখুন।",
    "start": "ঘুরে দেখা শুরু করুন",
    "later": "এখন নয়"
  },
  "card": {
    "tryIt": "ব্যবহার করে দেখুন",
    "takeALook": "একবার দেখুন",
    "pro": "Rhemn Pro-এর অংশ",
    "close_aria": "বন্ধ"
  },
  "pill": {
    "progress": "{{total}}টির মধ্যে {{count}}টি দেখা হয়েছে",
    "progress_short": "{{count}}/{{total}}",
    "done": "সম্পন্ন",
    "done_aria": "ঘুরে দেখা শেষ করুন",
    "complete": "সব দেখা হয়েছে"
  },
  "sr": {
    "started": "এক্সপ্লোর মোড চালু। বোতামগুলো কাজ করার আগে দেখায় সেগুলো কী করে।",
    "hint": "এক্সপ্লোর মোড। আগে দেখায় এটি কী করে।",
    "ended": "এক্সপ্লোর মোড বন্ধ।"
  },
  "settings": {
    "row": "Rhemn যেভাবে কাজ করে",
    "row_sub": "প্রতিটি অংশে এক ঝলক",
    "row_aria": "Rhemn যেভাবে কাজ করে: অ্যাপটি আবার ঘুরে দেখুন",
    "helpCaption": "সহায়তা"
  },
  "steps": {
    "intention": {
      "title": "আজকের নিয়ত",
      "body": "আজ যা সবচেয়ে গুরুত্বপূর্ণ, তা লিখুন, আর শেষ হলে টিক দিন।"
    },
    "now": {
      "title": "নামাজ ধরে আপনার দিন",
      "body": "Rhemn প্রতিটি নামাজে আপনার দিন ভাগ করে। এখানে পরের নামাজ পর্যন্ত বাকি সময় আর সে সময়ের জন্য আপনার পরিকল্পনা দেখা যায়।"
    },
    "verse": {
      "title": "আয়াতের অন্তর্দৃষ্টি",
      "body": "আজকের আয়াত নিয়ে প্রশ্ন করুন, সংক্ষিপ্ত তাফসীর পড়ুন, আর একই বিষয়ের আয়াত খুঁজে নিন।"
    },
    "qibla": {
      "title": "কিবলা",
      "body_chrome": "আপনার অবস্থান থেকে কাবার দিক, উত্তর থেকে কোণ হিসেবে।",
      "body_ios": "আপনার অবস্থান থেকে কাবার দিকে নির্দেশ করে। লাইভ কম্পাস চালু করুন, আপনি ঘুরলে এটিও ঘুরবে।"
    },
    "prayer": {
      "title": "নামাজের সময়",
      "body_chrome": "আপনার অবস্থানে আজকের পাঁচ ওয়াক্ত নামাজের সময়। আপনার মসজিদ যে গণনা পদ্ধতি অনুসরণ করে, সেটি বেছে নিন।",
      "body_ios": "পরের নামাজ এক নজরে। খুললে পাঁচ ওয়াক্তের সময় আর প্রতিটির জন্য অনুস্মারক পাবেন।"
    },
    "tasks": {
      "title": "কাজ",
      "body": "আপনার কাজগুলো তালিকায় রাখুন, আর প্রতিটিকে নামাজের মাঝে একটি জায়গা দিন।"
    },
    "notes": {
      "title": "নোট",
      "body_chrome": "লিখুন, অথবা শুধু বলুন। Rhemn আপনার কণ্ঠ নোট ও মিটিং লিখে নেয়, তারপর সারসংক্ষেপ করে।",
      "body_ios": "লিখুন, অথবা শুধু বলুন। Rhemn আপনার কথাকে গোছানো, সংক্ষিপ্ত নোটে রূপ দেয়।"
    },
    "profile": {
      "title_chrome": "আপনার প্রোফাইল",
      "body_chrome": "আপনার অ্যাকাউন্ট ও গোপনীয়তা সেটিংস। Rhemn আবার ঘুরে দেখতে এখানে ফিরে আসুন।",
      "title_ios": "আরও",
      "body_ios": "সংরক্ষিত আয়াত, কিবলা আর আপনার অ্যাকাউন্ট সেটিংস। এখান থেকে Rhemn আবার ঘুরে দেখতে পারেন।"
    }
  }
}
